import { useFloatingSave } from './floating-save/useFloatingSave'
import { FloatingSaveComponent } from './floating-save/FloatingSaveComponent'

/**
 * @deprecated Use FloatingSaveShadcnComponent with useFloatingSave directly
 */
export default function FloatingSave({
  isDirtyForm,
  handleSaveConfiguration,
  buttonLabel = `Save Changes`,
}: {
  isDirtyForm: boolean
  handleSaveConfiguration?: () => void | Promise<void>
  buttonLabel?: string
}) {
  const { visible, isSaving, buttonType, onSave } = useFloatingSave({ isDirtyForm, handleSaveConfiguration })
  return (
    <FloatingSaveComponent
      visible={visible}
      isSaving={isSaving}
      buttonType={buttonType}
      buttonLabel={buttonLabel}
      onSave={onSave}
    />
  )
}
